/** Synthetic phishing-shaped URL — do not visit. */
export const SAMPLE_URL =
	'https://user%40bank.example.invalid:pass@xn--pple-43d.com/%2e%2e/login?redirect=https%3A%2F%2Fevil.example%2F%3Fq%3D1&next=http://bit.ly/sample#<script>';
